export default "__VITE_ASSET__B7WM8_k8__"